import { FunctionComponent, useContext, useState } from "react";
import { ReferenceContext } from "providers/ReferenceProvider";
import styles from "./experience.module.scss";
import Title from "primitives/Title";
import jobData from "data/JobData";
import Button from "primitives/Button/Button";
import {
  ViewCompact,
  ViewComfy,
  NavigateBefore,
  NavigateNext,
} from "@material-ui/icons";
import Chip from "primitives/Chip";
import CardContent from "../../components/CardContent";

const Experience: FunctionComponent = () => {
  const [data, setData] = useState(jobData);
  const [currJobIdx, setCurrJobIdx] = useState(0);
  const refContext = useContext(ReferenceContext);
  const [expand, setExpand] = useState(false);
  const [filterChips, setFilterChips] = useState<string[]>([]);
  const chips = ["Part-time", "Internship"];

  const onNavigateBefore = () => {
    setCurrJobIdx((prevJob) => {
      if (prevJob === 0) {
        return data.length - 1;
      }
      return prevJob - 1;
    });
  };

  const onNavigateNext = () => {
    setCurrJobIdx((prevJob) => {
      if (prevJob === data.length - 1) {
        return 0;
      }
      return prevJob + 1;
    });
  };

  const setDataOnChipToggle = (filteredChips: string[]) => {
    setCurrJobIdx(0);
    const chipsSet = new Set(filteredChips);

    if (chipsSet.size === 0) {
      // reset to all initial data
      setData(jobData);
      return;
    }

    setData(jobData.filter((job) => chipsSet.has(job.type)));
  };

  const onChipToggle = (filterChipName: string) => {
    setFilterChips((prevState: string[]) => {
      if (prevState.includes(filterChipName)) {
        const filtered = prevState.filter((chip) => chip !== filterChipName);
        setDataOnChipToggle(filtered);
        return filtered;
      }
      setDataOnChipToggle([...prevState, filterChipName]);
      return [...prevState, filterChipName];
    });
  };

  return (
    <div
      className={`${styles.container} ${expand ? styles.expanded : ""}`}
      ref={refContext.experienceRef}
    >
      <Title>Experiences</Title>

      <div className={styles.filterContainer}>
        <div className={styles.chipContainer}>
          {chips.map((chip, index) => (
            <Chip
              onClick={() => onChipToggle(chip)}
              key={index}
              active={filterChips.includes(chip)}
            >
              {chip}
            </Chip>
          ))}
        </div>
        <Button onClick={() => setExpand(!expand)}>
          {expand ? <ViewCompact /> : <ViewComfy />}
        </Button>
      </div>

      <div className={styles.mainContent}>
        <Button
          onClick={onNavigateBefore}
          className={styles.desktop_navigation_button}
        >
          <NavigateBefore fontSize={"large"} />
        </Button>
        {data.map((job, index) => {
          if (expand) {
            return <CardContent dataType={job} key={index} expanded={expand} />;
          }

          if (index === currJobIdx)
            return <CardContent dataType={job} key={index} expanded={expand} />;
          return null;
        })}

        <Button
          onClick={onNavigateNext}
          className={styles.desktop_navigation_button}
        >
          <NavigateNext fontSize={"large"} />
        </Button>
        <div className={styles.phoneNavigation}>
          <Button onClick={onNavigateBefore}>
            <NavigateBefore fontSize={"large"} />
          </Button>
          <Button onClick={onNavigateNext}>
            <NavigateNext fontSize={"large"} />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Experience;
